module.exports = __webpack_public_path__ + "img/senar_branco.c3e97f8a.png";